<template>
  <div>
    <div class="row">
      <div class="col-12">
        <card-field title="Название">
          {{ data.name }}
        </card-field>

        <card-field :modelValue="data.code" title="Код"/>
        <card-field :modelValue="data.content_type ? data.content_type.name : '—' " title="Тип"/>
        <card-field title="Текст">
          <template v-if="data.is_html">
            <div v-if="data.text" v-html="strip_tags(data.text)"></div>
          </template>
          <template v-else>
            <div v-if="data.text" v-html="nl2br(data.text)"></div>
          </template>
        </card-field>
      </div>
    </div>

    <div class="mt-3">

      <div class="float-right">
        <button-remove @click="remove" v-if="can('module.content.delete')"/>
      </div>


      <button-edit @click="$router.push({name: 'content.edit', params: {id: data.id}})" v-if="can('module.content.update')"/>
    </div>
  </div>
</template>

<script>


export default {
  data() {
    return {}
  },
  props: {
    data: Object
  },
  mounted() {
  },
  methods: {

    remove() {
      $.alertConfirm({
        type: 'red',
      }, {
        ok: () => {
          axiosGetValue('/api/admin/content/delete', {id: this.data.id}, () => {
            toastSuccess('Удаление завершено');
            this.$router.push({name: 'content.list'})
          })
        }
      });
    },
  },
}
</script>